import { convertDigitToProperFormat } from '../../../../utils/number';

export const messages = {
  title: 'عنوان برنامه توسعه فردی',
  relatedRoles: 'گروه هدف',
  action: 'عملیات',
  addTopic: 'افزودن سرفصل آموزشی',
  nameCantBeEmpty: 'عنوان نمی‌تواند خالی باشد',
  termPhases: 'مراحل تکمیل /تایید نیاز آموزشی',
  addPhase: 'افزودن مرحله',
  addManagingRole: 'افزودن قانون',
  save: 'ذخیره',
  selectATerm: 'لطفا یک برنامه توسعه فردی را انتخاب کنید ',
  addTerm: 'افزودن برنامه توسعه فردی',
  phaseTitle: 'عنوان مرحله',
  startDate: 'تاریخ شروع:',
  endDate: 'تاریخ پایان:',
  duration: 'بازه فعال بودن:',
  whoManageWhom: 'قوانین تکمیل / تایید نیازسنجی در این مرحله',
  result: 'کارنامه',
  calendar: 'تقویم',
  assessmentStatus: 'فعالسازی نیازسنجی',
  others: 'سایر دوره ها',

  respectDistrict(roleName: string) {
    return `محدود شدن دسترسی ${roleName} فقط به بخش خود`;
  },
  topicLimits: 'محدودیت عناوین آموزشی',
  addLimit: 'افزودن محدودیت',
  relatedTag: 'برچسب مرتبط',
  selectAll: 'انتخاب همه سرفصل‌های مرتبط',
  minCount: 'حداقل تعداد',
  maxCount: 'حداکثر تعداد',
  noLimit: 'بدون محدودیت',
  managerRole: 'سمت تکمیل / تایید کننده',
  targetRoles: 'گروه هدف',
  showThisTerm: 'نمایش این برنامه',
  editableFields: 'پارامتر‌های قابل تغییر',
  areYouSureDeletePhase:
    'ایا از حذف این مرحله مطمئنی هستید؟ پس از ذخیره سازیی امکان بازگردانی آن وجود ندارد',
  areYouSureDeleteLimit: 'ایا مطمئن هستید؟',
  confirmDeleteTerm: 'ایا از حذف این برنامه توسعه فردی مطمئن هستید؟',
  delete: 'حذف این برنامه',
  deleted: 'حذف شده',
  settings: 'تنظیمات',
  edit: 'ویرایش',
  confirmRestoreTerm: 'ایا از بازگردانی این برنامه توسعه فردی مطمئن هستید؟',
  restore: 'بازگردانی',
  showDeleted: 'نمایش حذف شده ها',
  onlyAddTopic:
    'فقط امکان افزودن سرفصل به نیاز سنجی دارد (امکان تایید یا رد ندارد)',
  phaseHint: 'راهنمای فاز',
  createDuplicate: 'ساخت کپی',
  createDuplicateMessage:
    'با این کار یک کپی از این دوره با تنظیمات کنونی ایجاد می‌شود',
  copySuffix: '(کپی)',
  requests: 'نیازسنجی',
  courses: 'دوره‌ها',
  minMaxSelectable: 'حداقل و حداکثر موارد انتخابی',
  year: 'سال مرتبط',
  notificationWillBeSent:
    'کاربران از طریق ارسال خودکار پیامک در زمان شروع این مرحله از شروع نیاز سنجی آگاه می‌شوند',
  sendSMSToTargetUsersInPhase: 'ارسال پیامک به گروه هدف این فاز ',
  noRuleInfo:
    'در صورتی که قانونی برای این مرحله تعریف نشود، هر کاربر فقط می‌تواند برای خودش نیازسنجی را تکمیل کند',
  exporTopicStats: 'دریافت آمار سرفصل‌ها',
  basicSetting: 'تنظیمات پایه',
  newPhase: 'مرحله جدید',
  topics: 'سرفصل‌های آموزشی',
  documents: 'اسناد',
  duplicateUsers: 'کاربران تکراری',
  duplicateRoles: 'نقش های تکراری',
  duplicatedUserRoles: 'نقش ها و سمت های تکراری بر اساس گروه هدف انتخاب شده',

  termYear(year: string) {
    return `دوره‌های سال ${convertDigitToProperFormat(year)}`;
  },
  showDuplicate(termName: string, roleName: string) {
    return ` نقش «${roleName}» در «${termName}» تکرار شده است . `;
  },
  showDuplicateUsers(userName: string, termName: string) {
    return `کاربر «${userName}» در «${termName}» تکراری است. `;
  },
};
